import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { getDetectionList } from "./api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const ActionType = Object.freeze({
    base: "@@Monitoring/Action/Detection",
    getList: "getList"
});

export const getDetectionListAction = createAsyncThunk(
    `${ActionType.base}/${ActionType.getList}`,
    async(careRecipientId: CareRecipientId, { rejectWithValue }) => {
        const response = await getDetectionList(careRecipientId);

        if (response.error === undefined) {
            // API処理結果正常の場合
            return { ...response };
        } else {
            // API処理結果異常の場合
            return rejectWithValue({});
        }
    }
);
